export default __webpack_public_path__ + "static/media/avatar.731ae2f8.jpg";